<template>
  <a-table class="ant-table" v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-table>
</template>

<script setup lang="ts">
defineOptions({
  name: 'AntTable',
  inheritAttrs: false
})
</script>

<style lang="less" scoped>
:deep(.ant-table-thead > tr > th) {
  background: #F1F1F1 !important;
  color: #222 !important;
  font-weight: 500;
}

:deep(.ant-table-tbody > tr > td) {
  color: #5c5757;
}
</style>
